export default "__VITE_PUBLIC_ASSET__715fbefb__"